/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import styled from 'styled-components';
import Col from 'react-bootstrap/Col';

export const ColContainer = styled(Col)`
  background-color: #ededed;
  padding: 2% 5%;
  @media (max-width: 360px) {
    background-color: #fff;
  }
`;

export const AccHeader = styled.h3`
  font-size: 14px;
  font-weight: 600;
`;
